/**
 * VERA App - Root Component
 * Virtual Evidence & Reconstruction Archive Portal
 */
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./auth/AuthProvider";
import { Layout } from "./components/Layout/Layout";
import { DashboardPage } from "./pages/DashboardPage";
import { CasePage } from "./pages/CasePage";
import { EvidenceViewerPage } from "./pages/EvidenceViewerPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { AuditLogPage } from "./pages/AuditLogPage";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          {/* Dashboard - case overview */}
          <Route path="/" element={<DashboardPage />} />

          {/* Case detail - evidence listing */}
          <Route path="/case/:caseId" element={<CasePage />} />

          {/* Evidence viewer - 3D viewer + metadata */}
          <Route
            path="/case/:caseId/evidence/:evidenceId"
            element={<EvidenceViewerPage />}
          />

          {/* Admin - Audit Log */}
          <Route path="/admin/audit" element={<AuditLogPage />} />

          {/* 404 */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
};

export default App;
